




































import { Bank } from "@/types";
import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "SupportedBanks",

  props: {
    value: {
      type: String,
      default: "",
    },

    market: {
      type: String,
      default: "nl",
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.bankSelected = this.typedBanks.find(
          (bank) => bank.id === newValue
        );
      },
    },
    bankSelected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.$emit("input", newValue?.id);
      },
    },
  },

  mounted(): void {
    this.fetchBanks(this.market);
  },
  data: () => ({
    fetched: false,
    bankSelected: undefined as Bank | undefined,
  }),
  computed: {
    ...mapGetters({
      banks: "bankstatement/getBanks",
    }),
    // We solely do this to get some typing back
    typedBanks(): Bank[] {
      return this.banks;
    },
  },
  methods: {
    async fetchBanks(market = "nl") {
      try {
        await this.$store.dispatch("bankstatement/fetchBanks", market);
      } finally {
        this.fetched = true;
      }
    },
    redirectToBank(bankId: string): void {
      this.$store
        .dispatch("bankstatement/fetchConsentLink", bankId)
        .then((res) => {
          window.location.href = res.data;
        });
    },
  },
});
